import { http } from '../../main'
import { store } from '../../store'

const state = {}

const getters = {}

const actions = {
  companies_get ({commit, dispatch}, payload) {
    let url = 'api/company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('companyGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  companies_post ({commit, dispatch}, payload) {
    if (payload.event.item.file === null) {
      payload.event.item.file = undefined
    }
    let url = 'api/company'
    let params = {
      'name': payload.event.item.name,
      'tax_id': payload.event.item.tax_id,
      'phone': payload.event.item.phone,
      'regimen_fiscal': payload.event.item.regimen_fiscal,
      'razon_social': payload.event.item.razon_social,
      'logo': payload.event.item.file
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('companyPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  companies_put ({commit, dispatch}, payload) {
    // if (payload.event.item.name === payload.event.context.originalItem.name) {
    //   payload.event.item.name = undefined
    // }
    // if (payload.event.item.tax_id === payload.event.context.originalItem.tax_id) {
    //   payload.event.item.tax_id = undefined
    // }
    if (payload.event.item.file === null) {
      payload.event.item.file = undefined
    }
    let url = 'api/company/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name,
      'tax_id': payload.event.item.tax_id,
      'phone': payload.event.item.phone,
      'regimen_fiscal': payload.event.item.regimen_fiscal,
      'razon_social': payload.event.item.razon_social,
      'logo': payload.event.item.file
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, params, {})
      .then(
        response => {
          commit('companyPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  companies_delete ({commit, dispatch}, payload) {
    let url = 'api/company/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('companyDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  regimen_get ({commit, dispatch}, payload) {
    let url = 'api/sat/regimen-fiscal'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('regimenGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  companyGet (state, payload) {
    let companies = payload.response.data.data
    for (let index in companies) {
      if (typeof companies[index].subscriptions[0] !== 'undefined') {
        let expirationDate = new Date(companies[index].subscriptions[0].expiration_date)
        if (expirationDate > Date.now()) {
          companies[index].isVigent = true
        } else {
          companies[index].isVigent = false
        }
      } else {
        companies[index].isVigent = false
      }
    }
    payload.event.context.companies = companies
  },
  companyPost (state, payload) {
    let company = payload.response.data.data
    // company.name = company.name
    // company.tax_id = company.tax_id
    // company.phone = company.phone
    // company.regimen_fiscal = company.regimen_fiscal
    // company.razon_social = company.razon_social
    let companies = payload.event.context.companies
    companies.push(company)
    if (company.id !== null) {
      this.dispatch('areas/post_areas', {
        event: {
          name: 'Administración',
          company_id: company.id,
          context: payload.event.context
        }
      })
      this.dispatch('projects/project_post', {
        event: {
          name: 'general',
          company: company.id,
          status: 1,
          context: payload.event.context
        }
      })
      this.dispatch('branches/post', {
        event: {
          item: {
            street: 'default',
            city: 'default',
            state: 'default',
            sat_pais_id: 151,
            zip_code: '11111',
            branch_name: 'Matriz',
            company: {id: company.id}
          },
          context: payload.event.context
        }
      })
    }
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  companyPut (state, payload) {
    let company = payload.response.data.data
    // company.name = company.name
    // company.tax_id = company.tax_id
    // company.phone = company.phone
    // company.regimen_fiscal = company.regimen_fiscal
    // company.razon_social = company.razon_social
    let companies = payload.event.context.companies
    companies.splice(payload.event.index, 1, company)
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  companyDelete (state, payload) {
    let companies = payload.event.context.companies
    companies.splice(payload.event.index, 1)
    payload.event.context.companies = companies
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeRemoveDialog()
    payload.event.context.refresh()
  },
  regimenGet (state, payload) {
    let regimenList = payload.response.data.data
    payload.event.context.regimenList = regimenList
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/companies.js